/** A replaced CRDT must never reconnect or flush its pre-import draft. */
export function stopReplacedDocument(
  code: number | undefined,
  document: { loadOk: boolean; hydrated: boolean },
  provider: { disconnect(): void; destroy(): void },
): boolean {
  if (code !== 4410) return false;
  document.loadOk = false;
  document.hydrated = false;
  provider.disconnect();
  provider.destroy();
  return true;
}
